:host {
  display: block;
  line-height: 1.25rem;
  font-size: 0.875rem;
  color: #333333;
}

.max-capacity-cell__indicator-container {
  display: flex;
  align-items: center;
}

.max-capacity-cell__indicator {
  flex: 1 1 100%;
  min-width: 0;
}

.max-capacity-cell__measure-unit {
  flex: 1 0 auto;
  font-size: 0.875rem;
  min-width: 0;
}

:host(:not([dir="rtl"])) .max-capacity-cell__measure-unit {
  margin-left: 14px;
}

:host([dir="rtl"]) .max-capacity-cell__measure-unit {
  margin-right: 14px;
}